import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AccountLevelMetadataEnabled } from '../../types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountLevelMetadataEnabledQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountLevelMetadataEnabledQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, useAccountScopedFieldDefinitions: boolean } | null };


export const GetAccountLevelMetadataEnabled = /*#__PURE__*/ gql`
    query GetAccountLevelMetadataEnabled($accountId: ID!) {
  account(accountId: $accountId) {
    id
    ...AccountLevelMetadataEnabled
  }
}
    ${AccountLevelMetadataEnabled}` as unknown as DocumentNode<GetAccountLevelMetadataEnabledQuery, GetAccountLevelMetadataEnabledQueryVariables>;

          

          export const useGetAccountLevelMetadataEnabledQuery = (options?:QueryHookOptions<GetAccountLevelMetadataEnabledQuery, GetAccountLevelMetadataEnabledQueryVariables>) => useQuery(GetAccountLevelMetadataEnabled, options);

          

          export type GetAccountLevelMetadataEnabledQueryOptions = QueryHookOptions<GetAccountLevelMetadataEnabledQuery, GetAccountLevelMetadataEnabledQueryVariables>;

          

          export const useGetAccountLevelMetadataEnabledLazyQuery = (options?:LazyQueryHookOptions<GetAccountLevelMetadataEnabledQuery, GetAccountLevelMetadataEnabledQueryVariables>) => useLazyQuery(GetAccountLevelMetadataEnabled, options);

          

          export type GetAccountLevelMetadataEnabledQueryResult = ReturnType<typeof useGetAccountLevelMetadataEnabledQuery>;

          
